/*************************************************************
 * WARNING: This file was automatically generated by script. *
 *************************************************************/

/* eslint-disable @typescript-eslint/no-unused-vars */

import type { ValuesOf } from '@tmapy/beetlejuice-utils';

/**
 * ```yaml
 * type: string
 * description: |-
 *   * `WAITING_FOR_CHECKING` - Waiting for checking
 *   * `CHECKING` - Checking
 *   * `ABORTED` - Aborted
 *   * `FAILED` - Failed
 *   * `PASSED` - Passed
 *   * `INTERRUPTED` - Interrupted
 * ```
 */
export const DocCheckStateEnum = {
  WAITING_FOR_CHECKING: 'WAITING_FOR_CHECKING',
  CHECKING: 'CHECKING',
  ABORTED: 'ABORTED',
  FAILED: 'FAILED',
  PASSED: 'PASSED',
  INTERRUPTED: 'INTERRUPTED',
} as const;
// eslint-disable-next-line @typescript-eslint/no-redeclare
export type DocCheckStateEnum = ValuesOf<typeof DocCheckStateEnum>;

export type DocCheckStateEnumRequest = DocCheckStateEnum;
export type DocCheckStateEnumResponse = DocCheckStateEnum;
